var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewEvent({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.855469,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#EAEAEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10481_23625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.8555H8V26.8555C8 27.9555 8.9 28.8555 10 28.8555H24V26.8555H10V12.8555ZM26 8.85547H14C12.9 8.85547 12 9.75547 12 10.8555V22.8555C12 23.9555 12.9 24.8555 14 24.8555H26C27.1 24.8555 28 23.9555 28 22.8555V10.8555C28 9.75547 27.1 8.85547 26 8.85547ZM25 17.8555H21V21.8555H19V17.8555H15V15.8555H19V11.8555H21V15.8555H25V17.8555Z",
    fill: "#797979"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10481_23625"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(6 6.85547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewEvent);
export default __webpack_public_path__ + "static/media/create-new-event.899a3498f03621254f230c6a97446b3f.svg";
export { ForwardRef as ReactComponent };